/** Lat/Lng center + appropriate zoom level for each country code */
export interface CountryCoord {
  lat: number;
  lng: number;
  zoom: number;
}

export const COUNTRY_COORDS: Record<string, CountryCoord> = {
  AF: { lat: 33.93, lng: 67.71, zoom: 6 },
  AL: { lat: 41.15, lng: 20.17, zoom: 7 },
  DZ: { lat: 28.03, lng: 1.66, zoom: 5 },
  AD: { lat: 42.55, lng: 1.60, zoom: 10 },
  AO: { lat: -11.20, lng: 17.87, zoom: 5 },
  AG: { lat: 17.06, lng: -61.80, zoom: 10 },
  AR: { lat: -38.42, lng: -63.62, zoom: 4 },
  AM: { lat: 40.07, lng: 45.04, zoom: 7 },
  AU: { lat: -25.27, lng: 133.78, zoom: 4 },
  AT: { lat: 47.52, lng: 14.55, zoom: 7 },
  AZ: { lat: 40.14, lng: 47.58, zoom: 7 },
  BS: { lat: 25.03, lng: -77.40, zoom: 7 },
  BH: { lat: 26.07, lng: 50.56, zoom: 10 },
  BD: { lat: 23.68, lng: 90.36, zoom: 7 },
  BB: { lat: 13.19, lng: -59.54, zoom: 10 },
  BY: { lat: 53.71, lng: 27.95, zoom: 6 },
  BE: { lat: 50.50, lng: 4.47, zoom: 8 },
  BZ: { lat: 17.19, lng: -88.50, zoom: 8 },
  BJ: { lat: 9.31, lng: 2.32, zoom: 7 },
  BT: { lat: 27.51, lng: 90.43, zoom: 8 },
  BO: { lat: -16.29, lng: -63.59, zoom: 6 },
  BA: { lat: 43.92, lng: 17.68, zoom: 7 },
  BW: { lat: -22.33, lng: 24.68, zoom: 6 },
  BR: { lat: -14.24, lng: -51.93, zoom: 4 },
  BN: { lat: 4.54, lng: 114.73, zoom: 9 },
  BG: { lat: 42.73, lng: 25.49, zoom: 7 },
  BF: { lat: 12.24, lng: -1.56, zoom: 6 },
  BI: { lat: -3.37, lng: 29.92, zoom: 8 },
  KH: { lat: 12.57, lng: 104.99, zoom: 7 },
  CM: { lat: 7.37, lng: 12.35, zoom: 6 },
  CA: { lat: 56.13, lng: -106.35, zoom: 3 },
  CV: { lat: 16.00, lng: -24.01, zoom: 8 },
  CF: { lat: 6.61, lng: 20.94, zoom: 6 },
  TD: { lat: 15.45, lng: 18.73, zoom: 5 },
  CL: { lat: -35.68, lng: -71.54, zoom: 4 },
  CN: { lat: 35.86, lng: 104.20, zoom: 4 },
  CO: { lat: 4.57, lng: -74.30, zoom: 6 },
  KM: { lat: -11.88, lng: 43.87, zoom: 9 },
  CG: { lat: -0.23, lng: 15.83, zoom: 6 },
  CR: { lat: 9.75, lng: -83.75, zoom: 8 },
  HR: { lat: 45.10, lng: 15.20, zoom: 7 },
  CU: { lat: 21.52, lng: -77.78, zoom: 7 },
  CY: { lat: 35.13, lng: 33.43, zoom: 9 },
  CZ: { lat: 49.82, lng: 15.47, zoom: 7 },
  DK: { lat: 56.26, lng: 9.50, zoom: 7 },
  DJ: { lat: 11.83, lng: 42.59, zoom: 9 },
  DM: { lat: 15.41, lng: -61.37, zoom: 10 },
  DO: { lat: 18.74, lng: -70.16, zoom: 8 },
  EC: { lat: -1.83, lng: -78.18, zoom: 7 },
  EG: { lat: 26.82, lng: 30.80, zoom: 6 },
  SV: { lat: 13.79, lng: -88.90, zoom: 8 },
  GQ: { lat: 1.65, lng: 10.27, zoom: 8 },
  ER: { lat: 15.18, lng: 39.78, zoom: 7 },
  EE: { lat: 58.60, lng: 25.01, zoom: 7 },
  SZ: { lat: -26.52, lng: 31.47, zoom: 9 },
  ET: { lat: 9.15, lng: 40.49, zoom: 5 },
  FJ: { lat: -17.71, lng: 178.07, zoom: 7 },
  FI: { lat: 61.92, lng: 25.75, zoom: 5 },
  FR: { lat: 46.23, lng: 2.21, zoom: 6 },
  GA: { lat: -0.80, lng: 11.61, zoom: 7 },
  GM: { lat: 13.44, lng: -15.31, zoom: 9 },
  GE: { lat: 42.32, lng: 43.36, zoom: 7 },
  DE: { lat: 51.17, lng: 10.45, zoom: 6 },
  GH: { lat: 7.95, lng: -1.02, zoom: 7 },
  GR: { lat: 39.07, lng: 21.82, zoom: 6 },
  GD: { lat: 12.12, lng: -61.68, zoom: 10 },
  GT: { lat: 15.78, lng: -90.23, zoom: 7 },
  GN: { lat: 9.95, lng: -9.70, zoom: 7 },
  GW: { lat: 11.80, lng: -15.18, zoom: 8 },
  GY: { lat: 4.86, lng: -58.93, zoom: 7 },
  HT: { lat: 18.97, lng: -72.29, zoom: 8 },
  HN: { lat: 15.20, lng: -86.24, zoom: 7 },
  HU: { lat: 47.16, lng: 19.50, zoom: 7 },
  IS: { lat: 64.96, lng: -19.02, zoom: 6 },
  IN: { lat: 20.59, lng: 78.96, zoom: 5 },
  ID: { lat: -0.79, lng: 113.92, zoom: 4 },
  IR: { lat: 32.43, lng: 53.69, zoom: 5 },
  IQ: { lat: 33.22, lng: 43.68, zoom: 6 },
  IE: { lat: 53.14, lng: -7.69, zoom: 7 },
  IL: { lat: 31.05, lng: 34.85, zoom: 8 },
  IT: { lat: 41.87, lng: 12.57, zoom: 6 },
  CI: { lat: 7.54, lng: -5.55, zoom: 7 },
  JM: { lat: 18.11, lng: -77.30, zoom: 9 },
  JP: { lat: 36.20, lng: 138.25, zoom: 5 },
  JO: { lat: 30.59, lng: 36.24, zoom: 7 },
  KZ: { lat: 48.02, lng: 66.92, zoom: 4 },
  KE: { lat: -0.02, lng: 37.91, zoom: 6 },
  KI: { lat: -3.37, lng: -168.73, zoom: 7 },
  KW: { lat: 29.31, lng: 47.48, zoom: 9 },
  KG: { lat: 41.20, lng: 74.77, zoom: 7 },
  LA: { lat: 19.86, lng: 102.50, zoom: 6 },
  LV: { lat: 56.88, lng: 24.60, zoom: 7 },
  LB: { lat: 33.85, lng: 35.86, zoom: 8 },
  LS: { lat: -29.61, lng: 28.23, zoom: 8 },
  LR: { lat: 6.43, lng: -9.43, zoom: 7 },
  LY: { lat: 26.34, lng: 17.23, zoom: 5 },
  LI: { lat: 47.17, lng: 9.56, zoom: 11 },
  LT: { lat: 55.17, lng: 23.88, zoom: 7 },
  LU: { lat: 49.82, lng: 6.13, zoom: 10 },
  MG: { lat: -18.77, lng: 46.87, zoom: 5 },
  MW: { lat: -13.25, lng: 34.30, zoom: 6 },
  MY: { lat: 4.21, lng: 101.98, zoom: 6 },
  MV: { lat: 3.20, lng: 73.22, zoom: 7 },
  ML: { lat: 17.57, lng: -4.00, zoom: 5 },
  MT: { lat: 35.94, lng: 14.38, zoom: 10 },
  MR: { lat: 21.01, lng: -10.94, zoom: 5 },
  MU: { lat: -20.35, lng: 57.55, zoom: 9 },
  MX: { lat: 23.63, lng: -102.55, zoom: 5 },
  MD: { lat: 47.41, lng: 28.37, zoom: 7 },
  MC: { lat: 43.75, lng: 7.42, zoom: 13 },
  MN: { lat: 46.86, lng: 103.85, zoom: 5 },
  ME: { lat: 42.71, lng: 19.37, zoom: 8 },
  MA: { lat: 31.79, lng: -7.09, zoom: 6 },
  MZ: { lat: -18.67, lng: 35.53, zoom: 5 },
  MM: { lat: 21.91, lng: 95.96, zoom: 5 },
  NA: { lat: -22.96, lng: 18.49, zoom: 5 },
  NP: { lat: 28.39, lng: 84.12, zoom: 7 },
  NL: { lat: 52.13, lng: 5.29, zoom: 8 },
  NZ: { lat: -40.90, lng: 174.89, zoom: 5 },
  NI: { lat: 12.87, lng: -85.21, zoom: 7 },
  NE: { lat: 17.61, lng: 8.08, zoom: 5 },
  NG: { lat: 9.08, lng: 8.68, zoom: 6 },
  KP: { lat: 40.34, lng: 127.51, zoom: 7 },
  MK: { lat: 41.51, lng: 21.75, zoom: 8 },
  NO: { lat: 60.47, lng: 8.47, zoom: 5 },
  OM: { lat: 21.47, lng: 55.98, zoom: 6 },
  PK: { lat: 30.38, lng: 69.35, zoom: 5 },
  PA: { lat: 8.54, lng: -80.78, zoom: 7 },
  PG: { lat: -6.31, lng: 143.96, zoom: 6 },
  PY: { lat: -23.44, lng: -58.44, zoom: 6 },
  PE: { lat: -9.19, lng: -75.02, zoom: 5 },
  PH: { lat: 12.88, lng: 121.77, zoom: 6 },
  PL: { lat: 51.92, lng: 19.15, zoom: 6 },
  PT: { lat: 39.40, lng: -8.22, zoom: 7 },
  QA: { lat: 25.35, lng: 51.18, zoom: 9 },
  RO: { lat: 45.94, lng: 24.97, zoom: 7 },
  RU: { lat: 61.52, lng: 105.32, zoom: 3 },
  RW: { lat: -1.94, lng: 29.87, zoom: 8 },
  SA: { lat: 23.89, lng: 45.08, zoom: 5 },
  SN: { lat: 14.50, lng: -14.45, zoom: 7 },
  RS: { lat: 44.02, lng: 21.01, zoom: 7 },
  SC: { lat: -4.68, lng: 55.49, zoom: 9 },
  SL: { lat: 8.46, lng: -11.78, zoom: 7 },
  SG: { lat: 1.35, lng: 103.82, zoom: 11 },
  SK: { lat: 48.67, lng: 19.70, zoom: 7 },
  SI: { lat: 46.15, lng: 14.99, zoom: 8 },
  SO: { lat: 5.15, lng: 46.20, zoom: 5 },
  ZA: { lat: -30.56, lng: 22.94, zoom: 5 },
  KR: { lat: 35.91, lng: 127.77, zoom: 7 },
  SS: { lat: 6.88, lng: 31.31, zoom: 6 },
  ES: { lat: 40.46, lng: -3.75, zoom: 6 },
  LK: { lat: 7.87, lng: 80.77, zoom: 7 },
  SD: { lat: 12.86, lng: 30.22, zoom: 5 },
  SR: { lat: 3.92, lng: -56.03, zoom: 7 },
  SE: { lat: 60.13, lng: 18.64, zoom: 5 },
  CH: { lat: 46.82, lng: 8.23, zoom: 8 },
  SY: { lat: 34.80, lng: 39.00, zoom: 7 },
  TW: { lat: 23.70, lng: 120.96, zoom: 7 },
  TJ: { lat: 38.86, lng: 71.28, zoom: 7 },
  TZ: { lat: -6.37, lng: 34.89, zoom: 6 },
  TH: { lat: 15.87, lng: 100.99, zoom: 6 },
  TG: { lat: 8.62, lng: 0.82, zoom: 7 },
  TT: { lat: 10.69, lng: -61.22, zoom: 9 },
  TN: { lat: 33.89, lng: 9.54, zoom: 7 },
  TR: { lat: 38.96, lng: 35.24, zoom: 6 },
  TM: { lat: 38.97, lng: 59.56, zoom: 6 },
  UG: { lat: 1.37, lng: 32.29, zoom: 7 },
  UA: { lat: 48.38, lng: 31.17, zoom: 6 },
  AE: { lat: 23.42, lng: 53.85, zoom: 7 },
  GB: { lat: 55.38, lng: -3.44, zoom: 6 },
  US: { lat: 37.09, lng: -95.71, zoom: 4 },
  UY: { lat: -32.52, lng: -55.77, zoom: 7 },
  UZ: { lat: 41.38, lng: 64.59, zoom: 6 },
  VE: { lat: 6.42, lng: -66.59, zoom: 6 },
  VN: { lat: 14.06, lng: 108.28, zoom: 6 },
  YE: { lat: 15.55, lng: 48.52, zoom: 6 },
  ZM: { lat: -13.13, lng: 27.85, zoom: 6 },
  ZW: { lat: -19.02, lng: 29.15, zoom: 6 },
};
